import { EligibilityHouseholdMembersBanner } from "@/blocks/EligibilityHouseholdMembersBanner";
import {
  useCurrentHouseholdMemberQuery,
  useListHouseholdMembersQuery,
} from "@/data/queries/householdMembersQueries";
import { useTranslator } from "@/hooks/useTranslate";

export const EligibilityHouseholdMembersIndicator = () => {
  const { t } = useTranslator();
  const { data: householdMembers } = useListHouseholdMembersQuery();
  const { data: currentHouseholdMember } = useCurrentHouseholdMemberQuery();

  const otherMembers = (householdMembers ?? []).filter(
    member => member.id !== currentHouseholdMember?.id,
  );
  const members = [
    ...(currentHouseholdMember
      ? [
          {
            id: currentHouseholdMember.id,
            firstName:
              currentHouseholdMember.firstName ?? t("common:householdMember"),
            relationshipLabel: t("native:eligibilityHouseholdMembers.you"),
          },
        ]
      : []),
    ...otherMembers.map(member => ({
      id: member.id,
      firstName: member.firstName ?? t("common:householdMember"),
      relationshipLabel: member.householdMemberRelationship?.relationship
        ? t(
            `common:relationships.${member.householdMemberRelationship.relationship}`,
          )
        : "",
    })),
  ];

  return <EligibilityHouseholdMembersBanner members={members} />;
};
